import React, { useEffect, useState } from 'react';

import Icon from '../../../SurveyBuilder/components/Icon/Icon';
import Loader from '../../../../../../campaigns/components/CampaignResults/Blocks/Graphs/components/Loader/Loader';

import styles from './SurveyDetails.module.css';

export default ({
  survey,
  updateConfirmationStatus,
  allowedToChangeConfirmSurveyDetails,
  adminNeedsToConfirmDetails,
  incidenceRateLoaded,
  incidenceRateLoadHasError,
  totalIR
}) => {
  const [surveyDetailsConfirmed, setSurveyDetailsConfirmed] = useState(
    survey && survey.surveyDetailsConfirmed
  );
  const [
    surveyDetailsConfirmedByAdmin,
    setSurveyDetailsConfirmedByAdmin
  ] = useState(survey && survey.surveyDetailsConfirmedByAdmin);

  useEffect(
    () => {
      if (
        survey &&
        survey.surveyDetailsConfirmedByAdmin &&
        !surveyDetailsConfirmedByAdmin
      ) {
        setSurveyDetailsConfirmedByAdmin(true);
      }
    },
    [survey]
  );

  let incidenceRate = {
    name: 'Estimated IR',
    value: (
      <div style={{ right: '-8px', opacity: '0.5' }}>
        <Loader size="small" />
      </div>
    )
  };

  if (incidenceRateLoadHasError) {
    incidenceRate = {
      name: 'Estimated IR',
      value: 'Failed to load'
    };
  } else if (incidenceRateLoaded) {
    incidenceRate = {
      name: 'Estimated IR',
      value: totalIR ? `${parseFloat(totalIR * 100).toFixed(0)}%` : '0%'
    };
  }

  const surveyDetails = [
    {
      name: 'Customer',
      value:
        (survey &&
          survey.recordDetails &&
          survey.recordDetails.parent &&
          survey.recordDetails.parent.name) ||
        (survey && survey.recordDetails && survey.recordDetails.name) ||
        '-'
    },
    {
      name: 'Business challenge',
      value:
        survey &&
        survey.recordDetails &&
        survey.recordDetails.name &&
        survey.recordDetails.parent
          ? survey.recordDetails.name
          : '-'
    },
    {
      name: 'Translation',
      value: survey && survey.translationOfOtherSurvey ? 'Yes' : 'No'
    },
    {
      name: 'Sample size',
      value: (survey && survey.maxResponses) || 0
    },
    {
      name: 'Survey questions',
      value: (survey && survey.longestQuestionsPathCount) || 0
    },
    incidenceRate
  ];

  return (
    <div className={styles.container}>
      {surveyDetails.map(property => (
        <div className={styles.row}>
          <span>{property.name}</span>
          <span className={styles.value}>{property.value}</span>
        </div>
      ))}
      <div
        className={`${styles.confirmContainer} ${
          !allowedToChangeConfirmSurveyDetails || !incidenceRateLoaded
            ? styles.confirmContainerDisabled
            : ''
        }`}
      >
        <div
          className={styles.checkboxContainer}
          onClick={() => {
            if (allowedToChangeConfirmSurveyDetails && incidenceRateLoaded) {
              const newConfirmValue = adminNeedsToConfirmDetails
                ? !surveyDetailsConfirmedByAdmin
                : !surveyDetailsConfirmed;

              if (adminNeedsToConfirmDetails) {
                setSurveyDetailsConfirmedByAdmin(newConfirmValue);
                updateConfirmationStatus(
                  'surveyDetailsConfirmedByAdmin',
                  newConfirmValue
                );
              } else {
                setSurveyDetailsConfirmed(newConfirmValue);
                updateConfirmationStatus(
                  'surveyDetailsConfirmed',
                  newConfirmValue
                );
              }
            }
          }}
          role="presentation"
        >
          <Icon
            type={
              (adminNeedsToConfirmDetails
              ? surveyDetailsConfirmedByAdmin
              : surveyDetailsConfirmed)
                ? 'checkboxChecked'
                : 'checkboxUnChecked'
            }
          />
        </div>
        <span className={styles.confirmLabel}>
          By checking this box I confirm to have checked all of the above
        </span>
      </div>
    </div>
  );
};
